module.exports = __webpack_public_path__ + "static/cars4-d93d84c9c9d8e959f53c8bf1efda4548.png";